import NotificationEntity from '../../entities/notification/Notification'
import React from 'react'
import Box from '@mui/material/Box'
import { Alert, CloseButton } from './Notification.styled'
import CloseIcon from '@mui/icons-material/Close'

export interface IOwnProps { }

export interface IStateProps {
  notification?: NotificationEntity
}

export interface IDispatchProps {
  closeNotification: (id: string) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const Notification: React.FC<IProps> = (props) => {
  const {
    notification,
    closeNotification,
  } = props

  if (!notification) {
    return null
  }

  const handleCloseNotification = () => {
    closeNotification(notification.id)
  }

  return (
    <Box width='100%'>
      <Alert
        icon={false}
        severity='warning'
        variant='filled'
        action={
          <CloseButton
            color='inherit'
            size='small'
            onClick={handleCloseNotification}
          >
            <CloseIcon fontSize='inherit' />
          </CloseButton>
        }
      >
        {notification.text}
      </Alert>
    </Box>
  )
}

export default Notification
